module.exports = __webpack_public_path__ + "2340c0260066aaa9989824e23f67f1b8.png";